import {isResolvedStatus} from '../../tickets/constants/statuses';

/**
 * Whether the dashboard is currently scoped to settled work.
 *
 * The PRD (§8.1) gives Resolution time and Tags as "resolved-view extra
 * defaults" without naming what puts the dashboard into a resolved view. There is
 * only one control that can: the status filter. So the resolved view is the state
 * of having narrowed to resolved statuses and nothing else — every selected status
 * is settled. A mixed selection (`Open` + `Resolved`) is not a resolved view: half
 * its rows would have no resolution time, and promoting the column would fill the
 * table with dashes.
 *
 * An empty selection means "all statuses", which is the default view, not the
 * resolved one.
 */
export function isResolvedScope(appliedStatuses: readonly string[]): boolean {
	return appliedStatuses.length > 0 && appliedStatuses.every(isResolvedStatus);
}
